import provisionalRemedyRoutes from './provisional-remedy.route';
import costManagementRoutes from './cost-magement.route';
import budgetRoutes from './budget.route';
import contractEditorRoute from '../uspqrp/contract-editor.route';

const routes = [
  {
    path: 'uspqrp',
    component: () => import('@/views/uspqrp/UspqrpWrapper.vue'),
    children: [
      {
        path: 'menu',
        name: 'uspqrp',
        component: () => import('@/views/uspqrp/Menu.vue'),
      },
      provisionalRemedyRoutes,
      costManagementRoutes,
      budgetRoutes,
      contractEditorRoute,
    ],
  },
];

export default routes;
